import Vue from 'vue'
import Vuex from 'vuex'

import { clearTokens, getAccessToken, setTokens } from '@/api/http'
import { getMe } from '@/api/auth'
import { getPublicSettings } from '@/api/settings'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: getAccessToken(),
    me: null,
    settings: {},
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token
    },
    setMe(state, me) {
      state.me = me
    },
    setSettings(state, settings) {
      state.settings = settings
    },
  },
  actions: {
    async fetchSettings({ commit }) {
      try {
        const resp = await getPublicSettings()
        commit('setSettings', resp.data || {})
        return resp.data
      } catch (e) {
        console.error('Failed to fetch settings', e)
        return {}
      }
    },
    async login({ commit, dispatch }, tokens) {
      setTokens(tokens)
      commit('setAccessToken', tokens.access)
      await dispatch('fetchMe')
    },

    logout({ commit }) {
      clearTokens()
      commit('setAccessToken', '')
      commit('setMe', null)
    },
    async fetchMe({ commit, state }) {
      if (!state.accessToken) {
        commit('setMe', null)
        return null
      }
      const resp = await getMe()
      commit('setMe', resp.data || null)
      return resp.data
    },
  },
})
